import EditOutlineRoundedIcon from '@mui/icons-material/EditOutlined';
import { IconButton, Tooltip } from '@mui/material';

export const EditButtonIcon = ({ onClick, title }: any) => {
  return (
    <Tooltip onClick={onClick} title={title}>
      <IconButton aria-label="edit">
        <EditOutlineRoundedIcon style={{ fill: '#3b82f6', fontSize: '22px' }} />
      </IconButton>
    </Tooltip>
  );
};
